/*
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2023-11-16 14:24:54
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2023-12-27 11:15:53
 * @FilePath: \合联\oms\src\api\endTripManage\customerClearanceEndTripBill.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = ''

export const apis = buildApi({
  get: ['/Extract/customer_end&list', '/extract/customer_end&info', '/extract/clientExtract/tmExtractList', '/Extract/build_task&read', '/extract/clientExtract/shipmentDetails/:id&shipmentDetails'],
  post: ['/Extract/addExtractEnd', '/Extract/send_mail'],
  upload: ['/common/upload']
})